/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { adminHasPermission, cleanUpAdminCustomerDetailsRepayment } from '../../utils/helpers';
import useCustomQuery from '../../network/useCustomQuery';
import useGetQueryParams from '../../customHooks/useGetQueryParams';
import { GET_ADMIN_ALL_REPAYMENT } from '../../graphql/admin_queries';
import AdminTable from '../../components/AdminTable';
import DashboardHeader from '../../components/DashboardHeader';
import AdminLinkTabs from '../../components/AdminLinkTabs';
import useToast from '../../customHooks/useToast';
import useFilterMethods from '../../customHooks/useFilterMethods';
import EmptyRecord from '../../components/EmptyRecord';
import useTableColumn from '../../customHooks/useTableColumn';
import generatePDF from '../../utils/generatePdf';
import generateCSV from '../../utils/generateCSV';
// import EmptyAdminCuatomerIcon from '../../svgs/EmptyAdminCuatomerIcon';
import EmptyMerchantSettlement from '../../svgs/EmptyMerchantSettlement';
import { AdminRouteName } from '../CONSTANTS';
import CustomerTabs from '../AdminCustomers/CustomerTabs';
import { useGlobalState } from '../../contexts';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import PermissionDenied from '../PermissionDenied';
// import { useGlobalState } from '../../contexts/AdminGlobalContext';
// import { loadpayfiProduct } from '../../contexts/AdminGlobalContext';

const limit = 14;
interface IRepaymentTableRecords{
defaultUrl?:string;
toggleStorageId?:string;
tabStatus?:string;
hasNameAndImage?:boolean;
permissionName:string;
}
const RepaymentTableRecords = ({
  defaultUrl, toggleStorageId, tabStatus, hasNameAndImage, permissionName,
}:IRepaymentTableRecords) => {
  const Toast = useToast();
  const { profile } = useGlobalState();
  const adminPermissions = profile?.role?.permissions || [];
  const [getRepayment, getRepaymentLoading, repayments] = useCustomQuery({
    query: GET_ADMIN_ALL_REPAYMENT,
    onError: () => {},
    onData: () => {},
  });
  const TabsRaw = [
    {
      id: 1, name: 'All Repayments', link: AdminRouteName.repaymentsRoute, permission: 'can-get-repayments',
    },
    {
      id: 2, name: 'Due Repayments', link: AdminRouteName.dueRepaymentRoute, permission: 'can-view-due-repayments',
    },
    {
      id: 3, name: 'Upcoming Repayments', link: AdminRouteName.upcomingRepaymentRoute, permission: 'can-view-upcoming-repayments',
    },
    {
      id: 4, name: 'Defaulting Repayments', link: AdminRouteName.defaultRepaymentRoute, permission: 'can-view-defaulting-repayments',
    },
    {
      id: 5, name: 'Paid Repayments', link: AdminRouteName.paidRepaymentRoute, permission: 'can-view-paid-repayments',
    },
  ];

  const Tabs = TabsRaw?.map((tab) => ({
    ...tab,
    disabled: !adminHasPermission(adminPermissions, tab.permission),
  }));

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();

  const allColumns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'id',
    'phone',
    'amountDue',
    'tenor',
    ...(!tabStatus || tabStatus === 'paid' ? ['paymentMethod'] : []),
    'status',
    'repaymentdueDate',
    'payDate',
  ];

  const columnLabelFormat = {
    id: 'Repayment ID',
    name: 'Customer',
    phone: 'Phone Number',
    amountDue: 'Amount',
    tenor: 'Loan Tenor',
    interest: 'Interest Rate',
    repaymentdueDate: 'Due Date',
    payDate: 'Date Paid',
    paymentMethod: 'Payment Method',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [repaymentRec, setRepaymentRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`${defaultUrl}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`${defaultUrl}?page=1&search=${encodeURIComponent(e.target.value)}`);
  };
  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getRepayment({
        variables: tabStatus ? {
          offset: (page - 1) * limit,
          limit,
          search,
          statusFilter: tabStatus,
          filters: {
            from: result.from,
            to: result.to,
            channel: result?.partner,
            status: result?.status,
            tenor: result?.tenor,
            minAmount: result?.min ? Number(result?.min) : 0,
            maxAmount: result?.max ? Number(result?.max) : 0,
          },
        } : {
          offset: (page - 1) * limit,
          limit,
          search,
          statusFilter: tabStatus,
          filters: {
            from: result?.from,
            to: result?.to,
            channel: result?.partner,
            tenor: result?.tenor,
            status: result?.status,
            minAmount: result?.min ? Number(result?.min) : 0,
            maxAmount: result?.max ? Number(result?.max) : 0,
          },
        },
      });
    }
  }, [page, search]);

  const onFilterSubmit = (result) => {
    getRepayment({
      variables: {
        offset: 0,
        limit,
        search,
        statusFilter: tabStatus,
        filters: {
          from: result.from,
          to: result.to,
          channel: result?.partner,
          status: result?.status,
          tenor: result?.tenor,
          minAmount: result?.min ? Number(result?.min) : 0,
          maxAmount: result?.max ? Number(result?.max) : 0,
        },
      },
    });
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: tabStatus ? ['dateRange', 'amountRange', 'tenor'] : ['dateRange', 'status', 'amountRange', 'tenor'],
    defaultUrl,
    cb: onFilterSubmit,
    Toast,
    customFilterInformation: {
      dateRange: {
        label: 'Due Date',
      },
      status: {
        label: 'Status',
        options: [
          {
            label: 'Due',
            value: 'unpaid',
          },
          {
            label: 'Defaulting',
            value: 'due',
          },
          {
            label: 'Paid',
            value: 'paid',
          },
        ],
      },
    },
  });

  useEffect(() => {
    if (repayments?.getRepaymentsCa) {
      setRepaymentRec(repayments?.getRepaymentsCa);
    }
  }, [repayments]);

  const [getExportRecord] = useCustomQuery({
    query: GET_ADMIN_ALL_REPAYMENT,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          offset: 0,
          limit: 2000,
          search,
          statusFilter: tabStatus,
          filters: {
            from: result?.from,
            to: result?.to,
            channel: result?.partner,
            status: result?.status,
          },
        },
      });
      if (output?.data) {
        const rec = cleanUpAdminCustomerDetailsRepayment(output?.data?.getRepaymentsCa?.repayments);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'REPAYMENTS',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };

  return (
    <div>
      <DashboardHeader
        title="Repayments"
        smallSubTitle={`(${repaymentRec?.count || 0})`}
        searchPlaceholder="Search by repayment"
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getRepaymentLoading}
        filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        exportObj={{
          handleExport,
        }}
        disableExport={!adminHasPermission(adminPermissions, 'can-export-repayment-records')}
        disableSearch={!adminHasPermission(adminPermissions, 'can-search-repayment-records')}
        disbleFilter={!adminHasPermission(adminPermissions, 'can-filter-repayment-records')}

      >
        <AdminLinkTabs>

          <CustomerTabs Tabs={Tabs} />

        </AdminLinkTabs>
      </DashboardHeader>
      <RolesAndPermissionGuard permissionName={permissionName} hasErrorTemplate={<PermissionDenied height="60vh" />}>

        <div className="merchant-table-details-cover">
          {repaymentRec?.count ? (
            <AdminTable
              refreshing={getRepaymentLoading}
              page={page}
              setPage={setPage}
              pageSize={limit}
              minHeight="calc(100vh - 280px)"
              count={repaymentRec?.count}
              contents={cleanUpAdminCustomerDetailsRepayment(repaymentRec?.repayments)}
              reference="id"
              hideDominantImage
              clickable
              handleClick={(data) => push(`/repayments/repayment-details/${data?.id}`)}
              hasNameAndImage={hasNameAndImage}
              allowKeyArr={getColumns(true)}
              mobileAllowKeyArr={
                [
                  'status',
                  ['loanId', 'tenor'],
                  ['paymentChannel', 'dueDate'],
                ]
              }
              formatLabels={columnLabelFormat}
            />
          ) : (
            <EmptyRecord
              height="calc(100vh - 440px)"
              title={getRepaymentLoading ? 'Fetching repayments...' : 'No Repayments yet'}
              main="Customer has no repayment."
              // footer="Receive Payments"
              loading={getRepaymentLoading}
              Icon={EmptyMerchantSettlement}
            />
          )}

        </div>
      </RolesAndPermissionGuard>
    </div>
  );
};
export default RepaymentTableRecords;
